module.exports = __webpack_public_path__ + "components/country-flag/static/zm-a382c27893e287f5d0ee1df2f3ae3309.svg";